'use strict';

import zipObject from 'lodash/array/zipObject';
import map from 'lodash/collection/map';
import keys from 'lodash/object/keys';
import values from 'lodash/object/values';

function mapKeys(obj, iterator, context) {
  return zipObject(
    map(keys(obj), iterator, context),
    values(obj)
  );
}

export default mapKeys;


/** WEBPACK FOOTER **
 ** ./utils/mapKeys.js
 **/